"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAIForm = exports.AIFormProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const AIFormContext = (0, react_1.createContext)(undefined);
const AIFormProvider = ({ children }) => {
    const [fields, setFields] = (0, react_1.useState)([]);
    const registerField = (0, react_1.useCallback)((field) => {
        setFields(prev => {
            const existing = prev.find(f => f.name === field.name);
            if (existing) {
                return prev.map(f => f.name === field.name ? field : f);
            }
            return [...prev, field];
        });
    }, []);
    const unregisterField = (0, react_1.useCallback)((name) => {
        setFields(prev => prev.filter(f => f.name !== name));
    }, []);
    const updateFieldValue = (0, react_1.useCallback)((name, value) => {
        setFields(prev => prev.map(f => {
            if (f.name === name) {
                f.setValue(value);
                return { ...f, value };
            }
            return f;
        }));
    }, []);
    const getFields = (0, react_1.useCallback)(() => fields, [fields]);
    const clearFields = (0, react_1.useCallback)(() => setFields([]), []);
    return ((0, jsx_runtime_1.jsx)(AIFormContext.Provider, { value: { registerField, unregisterField, updateFieldValue, getFields, clearFields }, children: children }));
};
exports.AIFormProvider = AIFormProvider;
const useAIForm = () => {
    const context = (0, react_1.useContext)(AIFormContext);
    if (!context) {
        throw new Error('useAIForm must be used within AIFormProvider');
    }
    return context;
};
exports.useAIForm = useAIForm;
